import { render } from "./Reef Oasis.vue?vue&type=template&id=077d5dea&scoped=true"
const script = {}

import "./Reef Oasis.vue?vue&type=style&index=0&id=077d5dea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-077d5dea"

export default script